let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5nKJ0")]).then(() => parcelRequire('9J8Ay'));